import { render } from "./CoffeeArabica.vue?vue&type=template&id=8cce75aa"
import script from "./CoffeeArabica.vue?vue&type=script&lang=js"
export * from "./CoffeeArabica.vue?vue&type=script&lang=js"

import "@/assets/css/source-detail.css?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__